import Helper from "@ember/component/helper"

export function pluralize(params) {
  let len = params[0]
  let singular = params[1]
  let plural = params[2]
  return len === null || len === undefined || len === 0 || len > 1 ? plural : singular
}

export default class Pluralize extends Helper {
  compute = pluralize
}
